export const ABB_ORDERS_INDEX_NAME = 'abb_orders_data';
export const ABB_ORDERS_QUERY_SUGGESTIONS = 'abb_orders_data_query_suggestions';
export const ABB_QUOTES_INDEX_NAME = 'abb_quotes_v2_data';

export const errors = {
  email: "invalid email",
  pass: "invalid password"
};
export const database = [
  {
    email: "rm@crawfordelectric.test",
    password: "algolia@123",
    quotesAccounts: ["4162B0EUSS11010", "4162B0DUSS11010", "4162B0VUSS11010", "4162B12USS11010", "4162B0YUSS11010"],
    ordersAccounts: ["4162B0E", "4162B0D", "4162B0V", "4162B12", "4162B0Y"]
  },
  {
    email: "fenton@butlersupply.test",
    password: "algolia@123",
    quotesAccounts: ["1981011USS11010"],
    ordersAccounts: ["1981011"]
  }
];